import { CSS } from './';

export const blow: CSS = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
};

export const absolute: CSS = {
  ...blow,

  position: 'absolute',
};
export const fixed: CSS = {
  ...blow,
  position: 'fixed',
};
